import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/illustrations/coffee.png'


const _hoisted_1 = { class: "_leave-report _modal bg-white" }
const _hoisted_2 = { class: "_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Luca Education",
    title: "Luca Education",
    height: "150",
    width: "150"
  })
], -1)
const _hoisted_4 = { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5" }
const _hoisted_5 = { class: "text-center text-neutral-500 mt-2" }
const _hoisted_6 = {
  key: 0,
  class: "w-full mt-9"
}
const _hoisted_7 = { class: "input-group grid grid-cols-2 items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Từ ngày ", -1)
const _hoisted_9 = { class: "input-group grid grid-cols-2 items-center mt-10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Đến ngày ", -1)
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"input-group grid grid-cols-2 items-center mt-10\"><div class=\"input-group__label text-neutral-500 font-normal\"> Tổng số ngày nghỉ </div><div class=\"font-bold text-neutral-500 text-right\"> 07 ngày </div></div><div class=\"input-group grid grid-cols-2 items-center mt-10\"><div class=\"input-group__label text-neutral-500 font-normal\"> Tổng số buổi dạy cá nhân nghỉ </div><div class=\"font-bold text-neutral-500 text-right\"> 21 buổi dạy </div></div>", 2)
const _hoisted_13 = {
  key: 1,
  class: "w-full mt-9"
}
const _hoisted_14 = { class: "input-group grid grid-cols-2 items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Đến ngày nghỉ ", -1)
const _hoisted_16 = { class: "input-group grid grid-cols-2 items-center mt-10" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Từ giờ ", -1)
const _hoisted_18 = { class: "input-group grid grid-cols-2 items-center mt-10" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Đến giờ ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "input-group grid grid-cols-2 items-center mt-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Tổng số buổi dạy cá nhân nghỉ "),
  /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-neutral-500 text-right" }, " 3 buổi dạy ")
], -1)
const _hoisted_21 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_VueDatepicker = _resolveComponent("VueDatepicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.label), 1),
      (_ctx.leaveType && _ctx.leaveType === _ctx.ModalType.LEAVE_REPORT_LONG)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_VueDatepicker, {
                modelValue: _ctx.date,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
                class: "input-date w-full",
                placeholder: "Chọn ngày",
                enableTimePicker: false,
                format: "dd/MM/yyyy"
              }, {
                "input-icon": _withCtx(() => [
                  _createVNode(_component_DaIcon, {
                    name: "das--lock",
                    class: "h-4 w-4 text-neutral-400"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_VueDatepicker, {
                modelValue: _ctx.date,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.date) = $event)),
                class: "input-date w-full",
                placeholder: "Chọn ngày",
                enableTimePicker: false,
                format: "dd/MM/yyyy"
              }, {
                "input-icon": _withCtx(() => [
                  _createVNode(_component_DaIcon, {
                    name: "das--lock",
                    class: "h-4 w-4 text-neutral-400"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _hoisted_11
          ]))
        : _createCommentVNode("", true),
      (_ctx.leaveType && _ctx.leaveType === _ctx.ModalType.LEAVE_REPORT_SHORT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_VueDatepicker, {
                modelValue: _ctx.date,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.date) = $event)),
                class: "input-date w-full",
                placeholder: "Chọn ngày",
                enableTimePicker: false,
                format: "dd/MM/yyyy"
              }, {
                "input-icon": _withCtx(() => [
                  _createVNode(_component_DaIcon, {
                    name: "das--lock",
                    class: "h-4 w-4 text-neutral-400"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_VueDatepicker, {
                modelValue: _ctx.time,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.time) = $event)),
                class: "input-date w-full",
                placeholder: "Chọn giờ",
                timePicker: ""
              }, {
                "input-icon": _withCtx(() => [
                  _createVNode(_component_DaIcon, {
                    name: "das--lock",
                    class: "h-4 w-4 text-neutral-400"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_VueDatepicker, {
                modelValue: _ctx.time,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.time) = $event)),
                class: "input-date w-full",
                placeholder: "Chọn giờ",
                timePicker: ""
              }, {
                "input-icon": _withCtx(() => [
                  _createVNode(_component_DaIcon, {
                    name: "das--lock",
                    class: "h-4 w-4 text-neutral-400"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _hoisted_20
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.backOrClose && _ctx.backOrClose(...args)))
      }, _toDisplayString(_ctx.exitLabelButton), 1),
      (!_ctx.successfully)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "button-p text-center whitespace-nowrap",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
          }, _toDisplayString(_ctx.leaveType ? 'Xác nhận' : 'Nghỉ dài ngày'), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}